import { BlockContent } from '~/bootcamp/Activities/types/activities.types'
import { MatchingPairsQuestion } from '~/types/bootcamp'

let sortedData: sortedDataFormat[] = []

export interface sortedDataFormat {
  element1: BlockContent[]
  element2: BlockContent[]
  pairId: number
  key?: string
}

export function getData(questions: MatchingPairsQuestion[]): sortedDataFormat[] {
  sortData(questions)
  return sortedData
}

export function sortData(arg: MatchingPairsQuestion[]): void {
  // eslint-disable-next-line no-console
  sortedData = arg[0].pairs.map(
    (item: { element1: BlockContent[]; element2: BlockContent[]; _key?: string }, index: number) => {
      const data = {
        element1: {},
        element2: {},
        pairId: index,
        key: item._key,
      }
      data.element1 = item.element1
      data.element2 = item.element2

      return data
    },
  )
}
